import type { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
    authority: process.env.REACT_APP_AZURE_AUTHORITY || "",
    knownAuthorities: [process.env.REACT_APP_AZURE_KNOWN_AUTHORITIES || ""],
    redirectUri:
      process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

